import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/*
props:
 width: contents width
 height: contents height
 contents: display contents
 onChanged: callback function
 onClickNext: callback function
*/
class Slider extends Component {
    constructor(props) {
        super(props);

        this.count = 0;
        this.sliderSize = 0;

        this.slideMargin = 30;
        this.thresholdTime = 200;
        this.thresholdDistance = 50;

        this.touchBefore = 0;
        this.touchStart = 0;
        this.touchStartTime = null;
        this.direction = -1;
        this.current = 0;
        this.state = {
            pos: 0,
        }
    }

    componentDidMount() {
        this.count = Object.keys(this.props.contents).length;
        let width =  this.props.width.replace(/[^0-9]/g, '');
        this.sliderSize = width * this.count;
        this.forceUpdate();
    }
    goNext() {
        this.current++;
        if(this.current >= (this.count-1)) this.current = (this.count-1);

        let width =  this.props.width.replace(/[^0-9]/g, '');
        let pos = -(width * this.current);
        this.setState({
            pos: pos,
        })
    }
    goPrev() {
        this.current--;
        if(this.current < 0) this.current = 0;

        let width =  this.props.width.replace(/[^0-9]/g, '');
        let pos = -(width * this.current);
        this.setState({
            pos: pos,
        })
    }

    render() {
        const pos = 'translateX(' + this.state.pos + 'px)';
        return (
            <Body name='slider-body' width={this.props.width} height={this.props.height}>
                <ContentsWrap transform={pos}>
                    {this.props.contents}
                </ContentsWrap>
            </Body>
        );
    }
}

export { Slider };

Slider.propTypes = {
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    contents: PropTypes.array.isRequired,
    onChanged: PropTypes.func.isRequired,
};

const transitionDuration = 0.1;

const Body = styled.div`
    position: relative;
    width: ${props => (props.width)};
    height: ${props => (props.height)};
    z-index: 1;
`;
const ContentsWrap = styled.div.attrs(props => ({
    style: {transform: `${props.transform}` }
}))`
    display: flex;
    position: absolute;
    transition-duration: 0.1s;
`;
